import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createTimestampTransformer } from '../common/sql';
import { DBImageDigitisationRunSchema, ImageDigitisationRunSchema } from './schemas';

export const ImageDigitisationRunCodecConfig: TransformerConfig<
  typeof ImageDigitisationRunSchema,
  typeof DBImageDigitisationRunSchema
> = {
  name: 'ImageDigitisationRun',
  clientSchema: ImageDigitisationRunSchema,
  dbSchema: DBImageDigitisationRunSchema,
  transformers: [
    ...(['startedAt', 'finishedAt', 'updatedAt'] as const).map(field =>
      createTimestampTransformer<
        typeof ImageDigitisationRunSchema,
        typeof DBImageDigitisationRunSchema
      >(field, { nullable: true })
    ),
    createTimestampTransformer<
      typeof ImageDigitisationRunSchema,
      typeof DBImageDigitisationRunSchema
    >('createdAt'),
  ],
};

export const encodeImageDigitisationRunToDb = createEncodeToDbFn(ImageDigitisationRunCodecConfig);
export const decodeImageDigitisationRunFromDb = createDecodeFromDbFn(
  ImageDigitisationRunCodecConfig
);
